import { render, staticRenderFns } from "./farming.vue?vue&type=template&id=02a2471a&scoped=true&"
import script from "./farming.vue?vue&type=script&lang=js&"
export * from "./farming.vue?vue&type=script&lang=js&"
import style0 from "./farming.vue?vue&type=style&index=0&id=02a2471a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a2471a",
  null
  
)

export default component.exports